import React, { useState, useEffect } from "react";
import { InputNumber, Card } from "antd";
import Table from "../../core/pagination/datatable";
import { get100DaysROR, get100DaysRORBasedOnHistory } from "../../core/api/report";
import { useSelector } from "react-redux";

export default function ROR100Days() {
  const [rorValues, setRorValues] = useState({});
  const [rorHistoryValues, setRorHistoryValues] = useState({});
  const selectedClients = useSelector((state) => state.selectedClients);

  useEffect(() => {
    const loadData = async () => {
      // Load static RoR data
      const response = await get100DaysROR(selectedClients);
      const values = response.data;
      setRorValues(values);
      
      // Load history-based RoR data
      try {
        const historyResponse = await get100DaysRORBasedOnHistory(selectedClients);
        const historyValues = historyResponse.data;
        setRorHistoryValues(historyValues);
      } catch (error) {
        console.error("Error loading history-based RoR data:", error);
        setRorHistoryValues({});
      }
    };
    loadData();
  }, [selectedClients]);

  const columns = [
    {
      title: "Number of Days",
      dataIndex: "metric",
      key: "metric",
      fixed: "left",
      width: 250,
    },
    ...Object.keys(rorValues).map((day) => ({
      title: day,
      dataIndex: `day_${day}`,
      key: `day_${day}`,
      width: 80,
      align: "center",
      render: (_, record) => {
        if (record.metric === "Rate of Response % Static") {
          return (
            <InputNumber
              min={0}
              value={rorValues[day]}
              onChange={(value) => handleValueChange(day, value)}
              formatter={(val) => `${val}%`}
              parser={(val) => val.replace("%", "")}
              readOnly
            />
          );
        } else if (record.metric === "Rate of Response % Based on History") {
          return (
            <InputNumber
              min={0}
              value={rorHistoryValues[day]}
              formatter={(val) => `${val}%`}
              parser={(val) => val.replace("%", "")}
              readOnly
            />
          );
        }
        return null;
      },
    })),
  ];

  const dataSource = [
    {
      key: "1",
      metric: "Rate of Response % Static",
      ...Object.fromEntries(
        Object.keys(rorValues).map((day) => [`day_${day}`, rorValues[day]])
      ),
    },
    {
      key: "2",
      metric: "Rate of Response % Based on History",
      ...Object.fromEntries(
        Object.keys(rorHistoryValues).map((day) => [`day_${day}`, rorHistoryValues[day]])
      ),
    },
  ];

  const handleValueChange = (day, value) => {
    setRorValues((prev) => ({
      ...prev,
      [day]: value,
    }));
  };

  return (
    <Card className="p-4">
      <h4 className="text-lg font-semibold mb-4">
        Rate of Response - 100 Days
      </h4>
      <Table columns={columns} dataSource={dataSource} />
    </Card>
  );
}
